import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { BaseFilter } from 'ag-grid-community';
import { CompanyResource } from '../api-users/model/companyResource';
import { CompanyService } from '../api-users/api/company.service';

@Injectable({
    providedIn: 'root',
})
export class CompaniesService {
    private _company: BehaviorSubject<CompanyResource | null> = new BehaviorSubject<CompanyResource | null>(null);
    private _companies: BehaviorSubject<CompanyResource[] | null> = new BehaviorSubject<CompanyResource[] | null>(null);

    public actualFilter?: BaseFilter;

    constructor(private readonly _companiesDsService: CompanyService) {}

    get company$(): Observable<CompanyResource | null> {
        return this._company.asObservable();
    }

    get companies$(): Observable<CompanyResource[] | null> {
        return this._companies.asObservable();
    }

    public getCompany(idCompany: number) {
        return this._companiesDsService.getDetailCompany(idCompany).pipe(
            tap(company => {
                this._company.next(company);
            }),
        );
    }

    public getCompanies() {
        return this._companiesDsService.getCompanies().pipe(
            tap(companies => {
                this._companies.next(companies);
            }),
        );
    }

    searchCompanies(baseFilter: any): Observable<CompanyResource[]> {
        this.actualFilter = baseFilter;
        return this._companiesDsService.getCompanies().pipe(
            tap((companies: any) => {
                this._companies.next(companies);
            }),
        );
    }

    public updateCompany(editedCompany: number, company: any): Observable<any> {
        return this._companiesDsService.updateCompany(editedCompany, company);
    }

    public updateCompanyBrandingInfo(companyId: number, updateBrandingInfoRequest: any): Observable<CompanyResource> {
        return this._companiesDsService.updateCompanyBrandingInfo(companyId, updateBrandingInfoRequest);
    }
}
